<script>
import vue2Dropzone from "vue2-dropzone";
import CampaignApi from "@/services/campaign-api";
import ColorPickerField from "@/components/colorSelector";
import QrcodeVue from "qrcode.vue";
import InputTag from "vue-input-tag";
import { VueEditor } from "vue2-quill-editor";
import { mapGetters } from 'vuex';

export default {
  components: {
    VueEditor,
    vue2Dropzone,
    QrcodeVue,
    InputTag,
    ColorPickerField,
  },

  mounted() {
    this.findDetailsCampainById();
    this.$nextTick(() => {
      const mainContent = document.querySelector(".main-content");
      if (mainContent) {
        mainContent.style.overflow = "visible";
      }
    });
  },

    computed:{
        ...mapGetters('menu', ['menuCampaignId']),
    },

  data() {
    return {
      campaign: {
        id: null,
        isCollectingData: false,
        fieldsList: null,
        banner: null,
        rgb: "#FFFFFF",
        rgbButton: "#FFFFFF",
        description: null,
        goals: null,
        iosGoals: null,
        displayButton: false,
        textButton: null,
        oAuth2: false,
        oAuth2Facebook: false,
        oAuth2Google: false,
        rgbButtonText: "#FFFFFF",
        rgbText: "#000000",
        rgbButtonTextRangeAgeAndGender: "#000000",
        menuCode: null,
        isMenuCampaignWithOrder: false,
        isMenuCampaignWithQuote: false,
      },

      dataFields: [],

      dropzoneOptions: {
        url: "/",
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 1,
      },

      titleConfig: {
        show: false,
        text: "",
      },

      showColorBg: false,
      showColorModalBgButton: false,
      showColorModalrgbText: false,
      showColorModalButtonText: false,
      showColorModalButtonTextrangeAgeAndGender: false,

      customToolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          {
            color: ["#000000", "#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF","#00FFFF","#C0C0C0","#808080","#800000","#808000","#008000","#800080","#008080","#000080","#FFC0CB","#D3D3D3","#A52A2A","#5F9F9F","#FF6347","#40E0D0",],
          },
          {
            background: ["#000000","#FFFFFF", "#FF0000","#00FF00","#0000FF","#FFFF00","#FF00FF","#00FFFF","#C0C0C0","#808080","#800000","#808000","#008000","#800080","#008080","#000080","#FFC0CB","#A52A2A", "#5F9F9F", "#FF6347","#40E0D0",],
          },
        ],
        [{ align: [] }],
      ],
    };
  },

  watch: {
    menuCampaignId() {
      if (this.menuCampaignId) {
        this.findDetailsCampainById();
      }
    },
  },

  methods: {
    initcampaign() {
        this.getDataFields();
    },

    rgbaToHex8(color) {
      if (!color) return null;
      const rgba = color.rgba || {};
      const r = rgba.r ?? 0;
      const g = rgba.g ?? 0;
      const b = rgba.b ?? 0;
      const a = rgba.a ?? 1;

      const toHex = (v) => Number(v).toString(16).padStart(2, "0");
      const alpha = Math.round(a * 255);

      return (
        "#" +
        toHex(r) +
        toHex(g) +
        toHex(b) +
        toHex(alpha)
      ).toUpperCase();
    },

    changeColor({ color }) {
      this.campaign.rgb = this.rgbaToHex8(color);
    },

    changeColorRgbButton({ color }) {
      this.campaign.rgbButton = this.rgbaToHex8(color);
    },

    changeColorRgbText({ color }) {
      this.campaign.rgbText = this.rgbaToHex8(color);
    },

    changeColorRgbButtonText({ color }) {
      this.campaign.rgbButtonText = this.rgbaToHex8(color);
    },

    changeColorButtonTextrangeAgeAndGender({ color }) {
      this.campaign.rgbButtonTextRangeAgeAndGender =
        this.rgbaToHex8(color);
    },

    getDataFields() {
      CampaignApi.getDataFields().then((result) => {
        if (result) {
            this.dataFields = this.campaign.dataFieldsDTO == null  ? result : this.campaign.dataFieldsDTO

          if (
            this.campaign.oAuth2Facebook ||
            this.campaign.oAuth2Google
          ) {
            this.campaign.oAuth2 = true;
          }
        }
      });
    },

    downloadQRCode() {
      this.$nextTick(() => {
        const svgElement =
          this.$refs.qrCode?.$el.querySelector("svg");
        if (!svgElement) return;

        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgElement);
        const svgBlob = new Blob([svgString], {
          type: "image/svg+xml",
        });
        const url = URL.createObjectURL(svgBlob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "qrcode.svg";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });
    },

    findDetailsCampainById() {
      if (!this.menuCampaignId) return;

      CampaignApi.findDetailsCampainById(this.menuCampaignId).then(
        (result) => {
          if (result) {
            this.campaign = result;
            this.initcampaign();
          }
        }
      );
    },

    saveQrSettingsCampaign() {
      const formData = new FormData();

      if (this.campaign.isCollectingData) {
        const banner =
          this.$refs.myVueDropzone?.getAcceptedFiles()[0];
        if (banner) {
          formData.append("banner", banner);
        }
      }

      const campaignQrSetting = {
        id: this.campaign.id,
        isCollectingData: this.campaign.isCollectingData,
        rgbButton: this.campaign.rgbButton,
        rgb: this.campaign.rgb,
        htmlDescription: this.campaign.htmlDescription,
        fieldsList: this.dataFields,
        goals: this.campaign.goals,
        iosGoals: this.campaign.iosGoals,
        textButton: this.campaign.textButton,
        displayButton: this.campaign.displayButton,
        oAuth2Facebook:
          this.campaign.oAuth2 && this.campaign.oAuth2Facebook,
        oAuth2Google:
          this.campaign.oAuth2 && this.campaign.oAuth2Google,
        rgbText: this.campaign.rgbText,
        rgbButtonText: this.campaign.rgbButtonText,
        rgbButtonTextRangeAgeAndGender:
          this.campaign.rgbButtonTextRangeAgeAndGender,
      };

      CampaignApi.saveQrSettingsCampaign(
        formData,
        campaignQrSetting
      ).then((result) => {
        if (result) {
          this.campaign = result;
          if (
            this.campaign.oAuth2Facebook ||
            this.campaign.oAuth2Google
          ) {
            this.campaign.oAuth2 = true;
          }
        this.$store.dispatch("menu/setStateFromCampaign", this.campaign);
        }
      });
    },
  },
};
</script>

<template>
    <div>
        <div class="card pb-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-8 col-12">
                        <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">{{$t('campaign.card.qrSettings')}} </h2>
                    </div>

                    <div class="col-md-4 col-12 text-right">
                        <b-button variant="primary" @click="saveQrSettingsCampaign()" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="campaign.id == null">
                            {{$t("buttons.save")}}
                        </b-button> 
                    </div>
                </div>
                    
                <div class="row mt-5">
                    <div class="col-12 col-lg-9 pr-lg-2">
                        <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('campaign.input.goals')"  >
                            <b-input-group   >
                                <b-form-input  :placeholder="$t('campaign.input.goals')"  :disabled="campaign.id == null"
                                v-model="campaign.goals" ></b-form-input>                              
                            </b-input-group>
                        </b-form-group>

                        <b-form-group   class="font-weight-bold text-dark font-size-14 mt-4" :label="$t('campaign.input.iosGoals')"  >
                            <b-input-group   >
                                <b-form-input  :placeholder="$t('campaign.input.iosGoals')"   :disabled="campaign.id == null"
                                v-model="campaign.iosGoals" ></b-form-input>                              
                            </b-input-group>
                        </b-form-group>
                    </div>

                    <div v-if="campaign.code " class="col-lg-3 col-12 mb-md-0 mb-3 mt-4 mt-lg-0 d-flex justify-content-md-end justify-content-center">
                        <div>
                            <qrcode-vue ref="qrCode" :value="campaign.urlCode" :size="200" level="H" render-as="svg" />
                            <b-button variant="outline-secondary" class="mt-2" @click="downloadQRCode"   style="width: 100%;">
                                {{$t("campaign.text.downloadQRCode")}}
                            </b-button> 
                        </div>
                    </div>
                </div>

                <!-- Enable Collecting Data -->
                <div class="row mt-4">
                    <div class="col-12">
                        <b-form-group class="m-0">
                            <b-form-checkbox v-model="campaign.isCollectingData" switch class="float-md-left" :disabled="campaign.id == null"
                                :value="true">
                                <label class="font-weight-bold font-size-14" :class="campaign.isCollectingData ? 'text-primary' : 'text-muted'">{{$t('campaign.input.isCollectingData') }}</label>
                            </b-form-checkbox>
                        </b-form-group>
                    </div>
                </div>

                <div class="mt-3 "> 

                    <b-tabs  nav-class="nav-tabs-custom" content-class="mt-3 text-muted" active-nav-item-class="font-weight-bold text-uppercase ">
                        <b-tab >
                        <template v-slot:title>
                            <span class="font-size-16">Données collectées</span>
                        </template>

                            <div class="mt-2 px-lg-4 px-0">
                                <div class="row pb-4 font-size-12 mt-4">
                                    <div class="col-4 text-uppercase font-weight-bold text-info bg-light font-size-10"> {{$t('campaign.text.dataColected') }} </div>
                                    <div class="col-4 text-md-center text-right text-uppercase font-weight-bold text-info bg-light"> {{$t('campaign.text.required') }}</div>
                                    <div class="col-4 text-md-center text-right text-uppercase font-weight-bold text-info bg-light"> {{$t('campaign.text.requiredToOrder') }}</div>
                                </div>
                                <div v-for="(fields, index) in dataFields" :key="index" >
                                    
                                    <div class="row ">
                                        <div class="col-md-4 col-8">
                                            <b-form-checkbox :disabled="campaign.id == null" class="mb-0"  v-model="fields.isSelected" >
                                                    <div class=" text-left font-weight-bold font-size-14">{{ fields.input }}
                                                    </div>
                                            </b-form-checkbox>
                                        </div>

                                            <div class="col-md-4 col-2 text-md-center text-right">
                                                <b-form-checkbox
                                                    class="custom-checkbox custom-checkbox-danger  mb-3"
                                                    v-model="fields.isRequired" >
                                                </b-form-checkbox>
                                            </div>

                                            <div class="col-md-4 col-2 text-md-center text-right">
                                                <b-form-checkbox
                                                    class="custom-checkbox custom-checkbox-danger  mb-3"
                                                    v-model="fields.isRequiredToOrder" >
                                                </b-form-checkbox>
                                            </div>                                   
                                    </div>

                                    <div v-if="fields.isSelected && fields.code == 5 " class=" col-12 mb-4  ml-4">
                                        <div class="col-7">
                                            <div class="text-dark  font-size-14 pt-2 pb-2 "> {{$t('campaign.label.customQuestion')}} </div>
                                            <b-form-group   class="font-weight-bold font-size-14 m-0 pr-3"   >
                                                <b-input-group   >
                                                    <b-form-input  :placeholder="$t('campaign.input.question')"   
                                                    v-model="fields.question" ></b-form-input>                              
                                                </b-input-group>
                                            </b-form-group>
                                        </div>
                                        </div>
                                        <div v-else-if="fields.isSelected && fields.code == 6 "  class="mb-4 ml-4">
                                            <div class="col-7">
                                                <div class="text-dark  font-size-14 pt-2 pb-2"> {{$t('campaign.label.customQuestion')}} </div>
                                                <b-form-group   class="font-weight-bold font-size-14 m-0"   >
                                                    <b-input-group   >
                                                        <b-form-input  :placeholder="$t('campaign.input.question')"   
                                                        v-model="fields.question" ></b-form-input>                              
                                                    </b-input-group>
                                                </b-form-group>
                                            </div>
                                            <div class="col-7 text-left font-size-14 mt-2">
                                                <div class="text-dark  font-size-14 pt-2 pb-2 "> {{$t('campaign.label.customResponse')}} </div>
                                                <input-tag class="form-control font-size-12 h-100"  :placeholder="$t('campaign.input.response')" v-model="fields.response"></input-tag>
                                            </div>

                                            <div class="col-7">
                                                <div class="text-dark  font-size-14 pt-2 pb-2"> {{$t('campaign.label.identifier')}} </div>
                                                <b-form-group   class="font-weight-bold font-size-14 m-0"   >
                                                    <b-input-group   >
                                                        <b-form-input  :placeholder="$t('campaign.input.identifier')"   
                                                        v-model="fields.identifier" ></b-form-input>                              
                                                    </b-input-group>
                                                </b-form-group>
                                            </div>
                                        </div>
                                        <div v-else-if="fields.isSelected && fields.code == 3 "  class=" mb-4  ml-4">
                                            <div class="col-12">
                                                <div class="text-dark font-size-14 pt-2 pb-2">
                                                    {{ $t('campaign.label.rangeAge') }}
                                                </div>

                                                <div class="d-flex flex-wrap gap-3">

                                                    <!-- Range 1 -->
                                                    <div class="d-flex align-items-center  mr-0 mr-md-2">
                                                        <b-form-input
                                                            v-model="fields.range1Start"
                                                            class="age-input"
                                                            maxlength="2"
                                                            type="text"
                                                        />
                                                        
                                                        <img
                                                            alt=""
                                                            width="15"
                                                            class="mx-2"
                                                            src="@/assets/icons/right.svg"
                                                        />

                                                        <b-form-input
                                                            v-model="fields.range1End"
                                                            class="age-input"
                                                            maxlength="2"
                                                        />
                                                    </div>

                                                    <!-- Range 2 -->
                                                    <div class="d-flex align-items-center mr-0 mr-md-2 mt-md-0 mt-2">
                                                        <b-form-input
                                                            v-model="fields.range2Start"
                                                            class="age-input"
                                                            maxlength="2"
                                                        />

                                                        <img
                                                            alt=""
                                                            width="15"
                                                            class="mx-2"
                                                            src="@/assets/icons/right.svg"
                                                        />

                                                        <b-form-input
                                                            v-model="fields.range2End"
                                                            class="age-input"
                                                            maxlength="2"
                                                        />
                                                    </div>

                                                    <!-- Range 3 -->
                                                    <div class="d-flex align-items-center  mt-md-0 mt-2">
                                                        <b-form-input
                                                            v-model="fields.range3Start"
                                                            class="age-input"
                                                            maxlength="2"
                                                        />

                                                        <img
                                                            alt=""
                                                            width="15"
                                                            class="mx-2"
                                                            src="@/assets/icons/right.svg"
                                                        />

                                                        <b-form-input
                                                            v-model="fields.range3End"
                                                            class="age-input"
                                                            maxlength="3"
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                </div>  
                            </div>

                        </b-tab>

                        <b-tab>

                            <template v-slot:title>
                                <span class="font-size-16">Description Menu</span>
                            </template>


                            <div class="px-md-4 px-0">
                                <b-form-group  class="text-dark mt-4" label-for="">
                                    <vue-editor v-model="campaign.htmlDescription" :editorToolbar="customToolbar"
                                        class="qr-editor" style="background-color: white;"></vue-editor>
                                </b-form-group>
                            </div>

                        </b-tab>

                        <b-tab>

                            <template v-slot:title>
                                <span class="font-size-16">Couleur du thème</span>
                            </template>

                            <div class="row px-md-4 px-0">

                                <ColorPickerField
                                label="campaign.label.colorBg"
                                :showPicker.sync="showColorBg"
                                :colorValue="campaign.rgb"
                                :campaignId="campaign.id"
                                :titleConfig="titleConfig"
                                columnClass="col-md-6 col-12 my-2"
                                @updateColor="changeColor"
                                />

                                <ColorPickerField
                                label="campaign.label.colorText"
                                :showPicker.sync="showColorModalrgbText"
                                :colorValue="campaign.rgbText"
                                :campaignId="campaign.id"
                                :titleConfig="titleConfig"
                                columnClass="col-md-6 col-12 my-2"
                                @updateColor="changeColorRgbText"
                                />

                                <ColorPickerField
                                label="campaign.label.colorButton"
                                :showPicker.sync="showColorModalBgButton"
                                :colorValue="campaign.rgbButton"
                                :campaignId="campaign.id"
                                :titleConfig="titleConfig"
                                columnClass="col-md-6 col-12 my-2"
                                @updateColor="changeColorRgbButton"
                                />

                                <ColorPickerField
                                label="campaign.label.colorButtonText"
                                :showPicker.sync="showColorModalButtonText"
                                :colorValue="campaign.rgbButtonText"
                                :campaignId="campaign.id"
                                :titleConfig="titleConfig"
                                columnClass="col-md-6 col-12 my-2"
                                @updateColor="changeColorRgbButtonText"
                                />

                                <ColorPickerField
                                label="campaign.label.colorButtonTextrangeAgeAndGender"
                                :showPicker.sync="showColorModalButtonTextrangeAgeAndGender"
                                :colorValue="campaign.rgbButtonTextRangeAgeAndGender"
                                :campaignId="campaign.id"
                                :titleConfig="titleConfig"
                                columnClass="col-md-6 col-12 my-2"
                                @updateColor="changeColorButtonTextrangeAgeAndGender"
                                />

                            </div>

                        </b-tab>


                        <b-tab>

                            <template v-slot:title>
                                <span class="font-size-16">Bannière Publicitaire</span>
                            </template>

                                <div class="row mt-4 px-lg-4">

                                    <div class="col-md-12 col-12 text-left">
                                        <div class="row pb-4 font-size-16 mt-4">
                                            <div class="col-12 text-uppercase font-weight-bold text-info bg-light"> {{$t('campaign.label.image')}}</div>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12 text-center">
                                        <b-form-group class="text-dark font-weight-bold" :label="$t('campaign.text.bannerImageVideoType')" label-for="" :disabled="campaign.id == null"  >
                                            <vue2Dropzone class="m-0 p-0 m-md-2 p-md-1" id="dropzone" ref="myVueDropzone" maxFileSizeInMB="1" maxNumberOfFiles="1" :use-custom-slot="true" :options="dropzoneOptions">
                                                <div class="dropzone-custom-content text-center p-3">
                                                <img   alt=""  width="80px"  src="@/assets/icons/cloud-upload.svg"  />  
                                                    <h4 class="mb-0">{{ $t('parameters.dropImage') }}</h4>
                                                    <h5 class="text-warning font-size-9 text-Center mt-1" >{{ $t('parameters.imageSize') }} </h5>
                                                </div>
                                            </vue2Dropzone>
                                        </b-form-group>     
                                    </div>

                                    <div v-if="campaign.banner" class="col-md-6 col-12 my-auto text-center">
                                        <video   v-if="campaign.bannerMediaType === 1" style="max-width: 400px;" width="100%" height="auto" controls >
                                        <source :src="'/api/image/get/' + campaign.banner" type="video/mp4" />
                                        Votre navigateur ne supporte pas la lecture de vidéos.
                                        </video>

                                        <img    alt=""  style="max-width: 400px;"  width="100%"  height="auto"  :src="'/api/image/get/' + campaign.banner" />
                                    </div>
                                </div>

                        </b-tab>
                        

                        <b-tab>

                            <template v-slot:title>
                                <span class="font-size-16">Configuration générale</span>
                            </template>

                            <div class="row mt-4 px-lg-4">



                                <div class="col-md-12 col-12 text-left">
                                    <div class="row pb-4 font-size-16 mt-4">
                                        <div class="col-12 text-uppercase font-weight-bold text-info bg-light"> authentification OAuth2</div>
                                    </div>
                                    <b-form-group class="mt-4">
                                        <b-form-checkbox v-model="campaign.oAuth2" switch class="float-md-left" :disabled="campaign.id == null"
                                            :value="true" :unchecked-value="false">
                                            <label :class="campaign.oAuth2 ? 'text-primary' : 'text-muted'">{{$t('campaign.label.oAuth2') }}</label>
                                        </b-form-checkbox>
                                    </b-form-group>

                                    <div class="row" v-if="campaign.oAuth2"> 
                                        <div class="col-6">
                                            <b-form-checkbox   v-model="campaign.oAuth2Facebook"  class="float-md-left"
                                                :value="true" :unchecked-value="false">
                                                <label :class="campaign.oAuth2Facebook ? 'text-primary' : 'text-muted'">{{$t('campaign.label.oAuth2Facebook') }}</label>
                                            </b-form-checkbox>
                                        </div>
                                        <div class="col-6">
                                            <b-form-checkbox    v-model="campaign.oAuth2Google"  class="float-md-left" 
                                                :value="true" :unchecked-value="false">
                                                <label :class="campaign.oAuth2Google ? 'text-primary' : 'text-muted'">{{$t('campaign.label.oAuth2Google') }}</label>
                                            </b-form-checkbox>
                                        </div>
                                    </div>

                                </div>

                                <div class="col-md-12 col-12 text-left">
                                    <div class="row pb-4 font-size-16 mt-4">
                                        <div class="col-12 text-uppercase font-weight-bold text-info bg-light"> Bouton de validation</div>
                                    </div>
                                    <b-form-group class="mt-1">
                                    <b-form-checkbox v-model="campaign.displayButton" switch class="float-md-left" :disabled="campaign.id == null"
                                        :value="true" :unchecked-value="false">
                                        <label :class="campaign.displayButton ? 'text-primary' : 'text-muted'">{{$t('campaign.input.displayButton') }}</label>
                                    </b-form-checkbox>
                                    </b-form-group>


                                    <div v-if="campaign.displayButton" class="text-primary text-uppercase font-size-16 pb-2 "> {{$t('campaign.label.textButton')}} </div>

                                    <b-form-group v-if="campaign.displayButton"   class="font-weight-bold font-size-14" >
                                        <b-input-group   >
                                            <b-form-input  :placeholder="$t('campaign.input.textButton')"    :disabled="!campaign.displayButton"
                                            v-model="campaign.textButton" ></b-form-input>                              
                                        </b-input-group>
                                    </b-form-group>


                                </div>
                            </div>

                        </b-tab>
                    </b-tabs>
                </div>
            </div>           
        </div>
    </div>
</template>


<style scoped>
.color-picker {
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 50%; /* Makes it round */
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5); /* Adds a shadow */
    transition: transform 0.3s ease; /* Adds a smooth transition effect */
}

.color-picker:hover {
    transform: scale(1.1); /* Scales up the size on hover */
}


::v-deep .vue-input-tag-wrapper .new-tag{
    margin-left: 10px;
    font-family: "Cantarell", "Poppins", sans-serif;

    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    
    padding: 0.47rem 0.75rem;
    font-size: 0.8125rem;

}


::v-deep  .nav-tabs-custom .nav-item{
    margin-top: 10px !important;

}


</style>


<style scoped>
::v-deep .style-vselect-big-qr-setting .vs__dropdown-toggle {
  height: 100%;
  min-height: 38px;
  align-items: center;
  display: flex;
}

::v-deep .style-vselect-big-qr-setting-ar .vs__dropdown-toggle {
  height: 100%;
  min-height: 38px;
  align-items: center;
  display: flex;
}

::v-deep .style-vselect-big-qr-setting-ar .vs__dropdown-menu {
  font-family: 'Amiri', 'Tajawal', 'Noto Sans Arabic', sans-serif;
  direction: rtl;
  text-align: right;
}

::v-deep .style-vselect-big-qr-setting-ar .vs__search{
    color: #9fa2b0;
}

::v-deep .style-vselect-big-qr-setting .vs__search{
    color: #9fa2b0;
}

::v-deep .ql-container {
  max-height: 150px !important;
}

::v-deep .ql-editor {
  height: 150px !important;
  
}

</style>
